<div class="alert-list">
  <div class="header-title">{{ "MENUBAR.ERRORS_LIST" | translate }}</div>
  <div class="list-body">
    <div
      class="row"
      style="justify-content: center; align-items: center; margin-top: 5px;"
      *ngIf="errorsList.length != 0"
    >
      <button
        class="small-button"
        mat-stroked-button
        (click)="deleteAll()"
        [matTooltip]="'Delete all Notifications'"
      >
        <mat-icon class="svg-icon">delete</mat-icon>
      </button>
    </div>
    <mat-list class="matListScroll" role="list">
      <mat-list-item *ngIf="errorsList.length == 0" role="listitem">
        <div [ngClass]="'grid-errors'">
          No alerts yet...
        </div>
      </mat-list-item>
      <mat-list-item role="listitem" *ngFor="let item of errorsList">
        <!-- <div [ngClass]="item.isNew ? 'grid-errors-red' : 'grid-errors'"> -->
        <div [ngClass]="'grid-errors'">
          <div class="col">
            <div
              class="row"
              style="justify-content: space-between; align-items: center;"
            >
              <div>
                <button
                  class="small-button"
                  mat-stroked-button
                  (click)="setCenter(item.StreamName)"
                  [matTooltip]="'Center Camera'"
                >
                  <mat-icon class="svg-icon">place</mat-icon>
                </button>
                <button
                  class="small-button"
                  mat-stroked-button
                  (click)="openAro(item.StreamName)"
                  [matTooltip]="'Open Camera ARO'"
                >
                  <mat-icon class="svg-icon">assignment</mat-icon>
                </button>
              </div>
              <div class="wrap">{{ item.CameraName }}</div>
            </div>
          </div>
          <div class="text">Type: {{ item.Type }}</div>
          <div class="text">Description: {{ item.Message }}</div>
          <div class="spacediv text"></div>
          <div class="datetimediv text">{{ item.StringTime }}</div>
        </div>
        <div class="spacediv"></div>
      </mat-list-item>
    </mat-list>
  </div>
</div>
